var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatsMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 363.734,
    height: 237.773,
    viewBox: "0 0 363.734 237.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea2047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e61c64",
    stopOpacity: 0.502
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(331.051 -3024.586)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_4_8",
    "data-name": "4,8",
    transform: "translate(-325.051 3135.359)",
    fill: "#e61c64",
    fontSize: 7,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.156,
    y: 0
  }, "4,8")), /*#__PURE__*/React.createElement("text", {
    id: "_4_6",
    "data-name": "4,6",
    transform: "translate(-293.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.458,
    y: 0
  }, "4,6")), /*#__PURE__*/React.createElement("text", {
    id: "_4_6-2",
    "data-name": "4,6",
    transform: "translate(-277.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.458,
    y: 0
  }, "4,6")), /*#__PURE__*/React.createElement("text", {
    id: "_4_6-3",
    "data-name": "4,6",
    transform: "translate(-261.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.458,
    y: 0
  }, "4,6")), /*#__PURE__*/React.createElement("text", {
    id: "_4_6-4",
    "data-name": "4,6",
    transform: "translate(-245.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.458,
    y: 0
  }, "4,6")), /*#__PURE__*/React.createElement("text", {
    id: "_4_5",
    "data-name": "4,5",
    transform: "translate(-229.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.485,
    y: 0
  }, "4,5")), /*#__PURE__*/React.createElement("text", {
    id: "_4_5-2",
    "data-name": "4,5",
    transform: "translate(-213.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.485,
    y: 0
  }, "4,5")), /*#__PURE__*/React.createElement("text", {
    id: "_4_3",
    "data-name": "4,3",
    transform: "translate(-197.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.314,
    y: 0
  }, "4,3")), /*#__PURE__*/React.createElement("text", {
    id: "_4_3-2",
    "data-name": "4,3",
    transform: "translate(-181.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.314,
    y: 0
  }, "4,3")), /*#__PURE__*/React.createElement("text", {
    id: "_4_2",
    "data-name": "4,2",
    transform: "translate(-165.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.281,
    y: 0
  }, "4,2")), /*#__PURE__*/React.createElement("text", {
    id: "_4_2-2",
    "data-name": "4,2",
    transform: "translate(-149.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.281,
    y: 0
  }, "4,2")), /*#__PURE__*/React.createElement("text", {
    id: "_4_2-3",
    "data-name": "4,2",
    transform: "translate(-133.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.281,
    y: 0
  }, "4,2")), /*#__PURE__*/React.createElement("text", {
    id: "_4_2-4",
    "data-name": "4,2",
    transform: "translate(-117.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.281,
    y: 0
  }, "4,2")), /*#__PURE__*/React.createElement("text", {
    id: "_4_2-5",
    "data-name": "4,2",
    transform: "translate(-101.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.281,
    y: 0
  }, "4,2")), /*#__PURE__*/React.createElement("text", {
    id: "_4_1",
    "data-name": "4,1",
    transform: "translate(-85.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.573,
    y: 0
  }, "4,1")), /*#__PURE__*/React.createElement("text", {
    id: "_4_1-2",
    "data-name": "4,1",
    transform: "translate(-69.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.573,
    y: 0
  }, "4,1")), /*#__PURE__*/React.createElement("text", {
    id: "_3_9",
    "data-name": "3,9",
    transform: "translate(-53.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.239,
    y: 0
  }, "3,9")), /*#__PURE__*/React.createElement("text", {
    id: "_3_8",
    "data-name": "3,8",
    transform: "translate(-37.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.194,
    y: 0
  }, "3,8")), /*#__PURE__*/React.createElement("text", {
    id: "_3_6",
    "data-name": "3,6",
    transform: "translate(-21.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.233,
    y: 0
  }, "3,6")), /*#__PURE__*/React.createElement("text", {
    id: "_3_6-2",
    "data-name": "3,6",
    transform: "translate(-5.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.233,
    y: 0
  }, "3,6")), /*#__PURE__*/React.createElement("text", {
    id: "_3_4",
    "data-name": "3,4",
    transform: "translate(10.683 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.314,
    y: 0
  }, "3,4")), /*#__PURE__*/React.createElement("text", {
    id: "_3_3",
    "data-name": "3,3",
    transform: "translate(26.683 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.089,
    y: 0
  }, "3,3")), /*#__PURE__*/React.createElement("text", {
    id: "Sarigato_Sataku",
    "data-name": "Sarigato/Sataku",
    transform: "translate(-322.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 9,
    fontFamily: "Syne-Bold, Syne",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -80.928,
    y: 0
  }, "Sarigato/Sataku")), /*#__PURE__*/React.createElement("text", {
    id: "Tri-Table",
    transform: "translate(-290.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.376,
    y: 0
  }, "Tri-Table")), /*#__PURE__*/React.createElement("text", {
    id: "Grupa_Olx",
    "data-name": "Grupa Olx",
    transform: "translate(-274.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -35.464,
    y: 0
  }, "Grupa Olx")), /*#__PURE__*/React.createElement("text", {
    id: "Biuro_Reklamy_Grupa_Wyborcza",
    "data-name": "Biuro Reklamy Grupa Wyborcza",
    transform: "translate(-258.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -113.104,
    y: 0
  }, "Biuro Reklamy Grupa Wyborcza")), /*#__PURE__*/React.createElement("text", {
    id: "Biuro_Reklamy_Gazeta.pl",
    "data-name": "Biuro Reklamy Gazeta.pl",
    transform: "translate(-242.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -86.672,
    y: 0
  }, "Biuro Reklamy Gazeta.pl")), /*#__PURE__*/React.createElement("text", {
    id: "Mediafarm",
    transform: "translate(-226.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -39.344,
    y: 0
  }, "Mediafarm")), /*#__PURE__*/React.createElement("text", {
    id: "RMF_Digital",
    "data-name": "RMF Digital",
    transform: "translate(-210.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -40.912,
    y: 0
  }, "RMF Digital")), /*#__PURE__*/React.createElement("text", {
    id: "TikTok",
    transform: "translate(-194.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.656,
    y: 0
  }, "TikTok")), /*#__PURE__*/React.createElement("text", {
    id: "TVN_Media",
    "data-name": "TVN Media",
    transform: "translate(-178.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -39.136,
    y: 0
  }, "TVN Media")), /*#__PURE__*/React.createElement("text", {
    id: "Proxi.cloud",
    transform: "translate(-162.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -39.336,
    y: 0
  }, "Proxi.cloud")), /*#__PURE__*/React.createElement("text", {
    id: "Grupa_Eurozet",
    "data-name": "Grupa Eurozet",
    transform: "translate(-146.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -50.856,
    y: 0
  }, "Grupa Eurozet")), /*#__PURE__*/React.createElement("text", {
    id: "IDMnet",
    transform: "translate(-130.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.248,
    y: 0
  }, "IDMnet")), /*#__PURE__*/React.createElement("text", {
    id: "BR_RingierAxel_SPringer_Polska",
    "data-name": "BR RingierAxel SPringer Polska",
    transform: "translate(-114.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -106.872,
    y: 0
  }, "BR RingierAxel SPringer Polska")), /*#__PURE__*/React.createElement("text", {
    id: "Wirutalna_Polska",
    "data-name": "Wirutalna Polska",
    transform: "translate(-98.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -60.048,
    y: 0
  }, "Wirutalna Polska")), /*#__PURE__*/React.createElement("text", {
    id: "Biuro_Reklamy_TVP",
    "data-name": "Biuro Reklamy TVP",
    transform: "translate(-82.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -66.568,
    y: 0
  }, "Biuro Reklamy TVP")), /*#__PURE__*/React.createElement("text", {
    id: "BR_Internet_Programmatic_Performance_Grupa_ZPR_Media",
    "data-name": "BR Internet Programmatic /Performance Grupa ZPR Media",
    transform: "translate(-70.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -92.496,
    y: 0
  }, "BR Internet Programmatic"), /*#__PURE__*/React.createElement("tspan", {
    x: -114.032,
    y: 7
  }, "/Performance Grupa ZPR Media")), /*#__PURE__*/React.createElement("text", {
    id: "Polska_Press_Group",
    "data-name": "Polska Press Group",
    transform: "translate(-50.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -67.16,
    y: 0
  }, "Polska Press Group")), /*#__PURE__*/React.createElement("text", {
    id: "Grupa_Allegro",
    "data-name": "Grupa Allegro",
    transform: "translate(-34.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -47.984,
    y: 0
  }, "Grupa Allegro")), /*#__PURE__*/React.createElement("text", {
    id: "Polsat_Media",
    "data-name": "Polsat Media",
    transform: "translate(-18.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -45.952,
    y: 0
  }, "Polsat Media")), /*#__PURE__*/React.createElement("text", {
    id: "Aleph",
    transform: "translate(-2.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.16,
    y: 0
  }, "Aleph")), /*#__PURE__*/React.createElement("text", {
    id: "Meta",
    transform: "translate(13.683 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18.544,
    y: 0
  }, "Meta")), /*#__PURE__*/React.createElement("text", {
    id: "Google_i_YouTube",
    "data-name": "Google i YouTube",
    transform: "translate(30.683 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -60.448,
    y: 0
  }, "Google i YouTube")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 10,
    height: 100,
    transform: "translate(-330.317 3024.586)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 10,
    height: 98.263,
    transform: "translate(-314.317 3026.546)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 10,
    height: 96.175,
    transform: "translate(-298.317 3028.634)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 10,
    height: 96.175,
    transform: "translate(-282.317 3028.634)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 10,
    height: 96.175,
    transform: "translate(-266.317 3028.634)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 10,
    height: 96.175,
    transform: "translate(-250.317 3028.634)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 10,
    height: 94.087,
    transform: "translate(-234.317 3030.722)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 10,
    height: 94.087,
    transform: "translate(-218.317 3030.722)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 10,
    height: 89.911,
    transform: "translate(-202.317 3034.898)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 10,
    height: 89.911,
    transform: "translate(-186.317 3034.898)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 10,
    height: 87.823,
    transform: "translate(-170.317 3036.986)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 10,
    height: 87.823,
    transform: "translate(-154.317 3036.986)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 10,
    height: 87.823,
    transform: "translate(-138.317 3036.986)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 10,
    height: 87.823,
    transform: "translate(-122.317 3036.986)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 10,
    height: 87.822,
    transform: "translate(-106.317 3036.986)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 10,
    height: 85.735,
    transform: "translate(-90.317 3039.074)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 10,
    height: 85.735,
    transform: "translate(-74.317 3039.074)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 10,
    height: 81.559,
    transform: "translate(-58.317 3043.25)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 10,
    height: 79.471,
    transform: "translate(-42.317 3045.338)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 10,
    height: 75.295,
    transform: "translate(-26.317 3049.514)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 10,
    height: 75.295,
    transform: "translate(-10.317 3049.514)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 10,
    height: 71.247,
    transform: "translate(5.683 3053.691)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 10,
    height: 69.031,
    transform: "translate(21.683 3055.779)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_4_7",
    "data-name": "4,7",
    transform: "translate(-309.317 3135.359)",
    fill: "#2f2e2f",
    fontSize: 6,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.314,
    y: 0
  }, "4,7")), /*#__PURE__*/React.createElement("text", {
    id: "YOC_Poland",
    "data-name": "YOC Poland",
    transform: "translate(-306.317 3147.359) rotate(-90)",
    fill: "#2f2e2f",
    fontSize: 8,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -42.2,
    y: 0
  }, "YOC Poland")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsMobile);
export default __webpack_public_path__ + "static/media/stats-mobile.d51ebce6c4011eb06ce5a04566d66b7b.svg";
export { ForwardRef as ReactComponent };